import { Modal } from 'antd';
import React, { useState } from 'react';
import { voltarRateioPendente, validarDocumentosAutorizacao } from '@app/api/planilhaRateio';
import { Button } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import './modal.css';

export interface PropsModalComentario {
  id: string;
  onUpdatePage: () => any;
}

const ModalJustificativaVoltarRateioPendente = (props: PropsModalComentario) => {
  const { id, onUpdatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');
  const [botaoAutorizacao, setBotaoAutorizacao] = useState(false);

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      (document.getElementById(textAreaId) as HTMLInputElement).value = '';
    }
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const SalvarComAutorizacao = (e: any) => {
    voltarRateioPendente(id, { rateioId: id, justificativa: justificativa }).then(data => {
      if (data) {
        limparCampo();
        if (data.valid) {
          onUpdatePage();
        }
      }
    });
  };

  const Salvar = (e: any) => {
    validarDocumentosAutorizacao(id).then((data: any) => {
      if (data.possuiDocumentosAutorizacao === true) {
        setBotaoAutorizacao(true);
      } else {
        voltarRateioPendente(id, { rateioId: id, justificativa: justificativa }).then(data => {
          if (data) {
            limparCampo();
            if (data.valid) {
              onUpdatePage();
            }
          }
        });
      }
    });
  };

  return (
    <>
      <Button
        id="btnDonwloadModelo"
        icon="arrows-rotate_left"
        type="link"
        onClick={() => {
          showModal();
        }}>
        VOLTAR RATEIO PARA PENDENTE
      </Button>

      <Modal
        title="Justificativa para voltar o rateio para pendente"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" icon="commons-checkmark" onClick={e => Salvar(e)}>
            Confirmar
          </Button>,
          <Button key="cancel" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <p>
          Favor considerar que as autorizações e arquivos anexos ao rateio serão <b>EXCLUIDOS</b> e que <b>TODO</b> o
          processo deverá feito novamente, inclusive integração Totvs e envio de e-mail ao fornecedor.
        </p>
        <TextArea
          name="justificativa"
          id="justificativa"
          required
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
        />
      </Modal>

      <Modal
        title="Atenção"
        visible={botaoAutorizacao}
        onCancel={() => {
          setBotaoAutorizacao(false);
        }}
        footer={[
          <Button key="submit" type="link" icon="commons-checkmark" onClick={e => SalvarComAutorizacao(e)}>
            Confirmar
          </Button>,
          <Button key="cancel" type="primary" onClick={() => setBotaoAutorizacao(false)}>
            Fechar
          </Button>,
        ]}>
        <p>A autorização possui documentos de cobrança, os mesmos serão deletados, deseja continuar?</p>
      </Modal>
    </>
  );
};

export default ModalJustificativaVoltarRateioPendente;
